module.exports = __webpack_public_path__ + "static/ftp-banner-bfdbeee3bac1cfe909add4e7fb3282ae.png";